import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Breadcrumb,
  Button,
  Container,
  Row,
  Col,
  Table,
  Spinner,
  Form,
  FloatingLabel,
} from "react-bootstrap";

import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import BaseAPI from "../../../api/BaseAPI";
import NextAndPreviousPageAPI from "../../../api/NextAndPreviousPageAPI";
import ModalCadastrarUsuario from "../components/ModalCadastrarUsuario";
import ModalEditarUsuario from "../components/ModalEditarUsuario";
import ModalAlterarSenha from "../components/ModalAlterarSenha";
import RenderIf from "../../../design_system/RenderIf";

function ListaUsuarios() {
  const [usuarios, setUsuarios] = useState([{}]);
  const [carregando, setCarregando] = useState(true);
  const [qtdUsuarios, setQtdUsuarios] = useState(0);

  const { register, handleSubmit } = useForm({
    defaultValues: {
      name: "",
      ativo: false,
    },
  });

  const getUsuarios = (values) => {
    setCarregando(true);
    let ativo = false;
    let name = ""
    if (values && values.ativo) {
      ativo = values.ativo;
    } 
    if (values && values.name) {
      name = values.name;
    }
    BaseAPI.get("/usuarios/lista_usuarios/", {
      params: {
        ativo: ativo,
        name: name,
      },
    })
      .then((response) => {
        const { data } = response;
        setUsuarios(data);
        setCarregando(false);
      })
      .catch((err) => {
        alert(err);
      });

      BaseAPI.get("util/total_tabela/", {
        params: {model: "usuarios"}
      })
      .then((response) => {
        const { data } = response;
         setQtdUsuarios(data.total)
      })
      .catch((err) => {
        alert(err);
      });
  };

  const nextPage = () => {
    const url = new URL(usuarios.next);
    const path = url.pathname.substring(7) + url.search;
    NextAndPreviousPageAPI.get(path)
      .then((response) => {
        const { data } = response;
        setUsuarios(data);
        setCarregando(false);
      })
      .catch((err) => {
        alert(err);
      });
  };
  const previousPage = () => {
    const url = new URL(usuarios.previous);
    const path = url.pathname.substring(7) + url.search;
    NextAndPreviousPageAPI.get(path)
      .then((response) => {
        const { data } = response;
        setUsuarios(data);
        setCarregando(false);
      })
      .catch((err) => {
        alert(err);
      });
  };

  useEffect(() => {
    getUsuarios();
  }, []);

  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Cadastro de usuários</Breadcrumb.Item>
      </Breadcrumb>
      <form onSubmit={handleSubmit(getUsuarios)}>
        <Row className="my-4">
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              label="Nome"
              className="mb-3"
            >
              <Form.Control type="text" {...register("name")} />
            </FloatingLabel>
          </Col>
          <Col sm>
            <FloatingLabel
              controlId="floatingInput"
              className="mb-3"
            >
            <Form.Check 
              id="ativo"
              label="Ativo"
              type="checkbox"
              {...register("ativo")}
            />
            </FloatingLabel>
          </Col>
          <Col sm className="mt-2">
            <Button className="mx-1" onClick={handleSubmit(getUsuarios)}>
              <ManageSearchIcon />
            </Button>
            <ModalCadastrarUsuario getUsuarios={getUsuarios} />
          </Col>
        </Row>
      </form>
      Total Usuários: {qtdUsuarios}
      <Table striped responsive bordered>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th>Função</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {carregando && <Spinner animation="border" variant="primary" />}
          {!carregando &&
            usuarios.results.length > 0 &&
            usuarios.results.map((usuario) => {
              return (
                <tr key={usuario.id}>
                  <td>{usuario.first_name}</td>
                  <td>{usuario.email}</td>
                  <td>
                    {usuario.funcao === "A"
                      ? "Administrador"
                      : usuario.funcao === "V"
                      ? "Vendedor"
                      : usuario.funcao === "S"
                      ? "Superusuario"
                      : ""}
                  </td>
                  <td>
                    <Row className="w-75">
                      <Col sm={3}>
                        <ModalEditarUsuario
                          idUsuario={usuario.id}
                          getUsuarios={getUsuarios}
                        />
                      </Col>
                      <Col sm={3}>
                        <ModalAlterarSenha
                          idUsuario={usuario.id}
                          getUsuarios={getUsuarios}
                          variant={"warning"}
                        />
                      </Col>
                    </Row>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center">
        <RenderIf condicao={usuarios.next}>
          <div className="m-1">
            <Button variant="primary" onClick={nextPage}>
              Próxima página
            </Button>
          </div>
        </RenderIf>
        <RenderIf condicao={usuarios.previous}>
          <div className="m-1">
            <Button variant="primary" onClick={previousPage}>
              &lt;
            </Button>
          </div>
        </RenderIf>

        <RenderIf condicao={usuarios.next}>
          <div className="m-1">
            <Button variant="primary" onClick={nextPage}>
              &gt;
            </Button>
          </div>
        </RenderIf>
      </div>
    </Container>
  );
}

export { ListaUsuarios };
export default ListaUsuarios;
